import { render } from "./AllCoins.vue?vue&type=template&id=b1e6a1bc"
import script from "./AllCoins.vue?vue&type=script&lang=js"
export * from "./AllCoins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__